const styles = theme => ({
    wrapper: {
        position: 'fixed',
        bottom: 20,
        right: 50,
        '@media (max-width: 380px)': {
            right: 10,
            bottom: 10
        }
    },
    speedDial: {
        margin: '0 20%'
    },
    listItem: {
        color: theme.palette.secondary.dark
    },
    drawer: {
        zIndex: 1300 //drawer z-index gets overridden ??
    }
});

export default styles;